import { useApolloClient } from '@apollo/client';

export const useEvitCache = () => {
  const apolloClient = useApolloClient();

  return evictQuery => {
    const cacheId = apolloClient.cache.identify(evictQuery);
    apolloClient.cache.evict({ id: cacheId });
    apolloClient.cache.gc();
  };
};
